import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Dropzone from 'react-dropzone';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import './ImagesUpload.css';
import {clientMedia} from "../../../Config/Settings";

class ImagesUpload extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isSizesOpen: false
        }
    }

    getMainImage() {
       // if (this.props.files && this.props.files[0]) return this.props.files[0].preview;

        return `${clientMedia()}/img/icons/add-image.png`
    }

    renderImages() {
        if (!this.props.uploadedImages) return null;

        return this.props.uploadedImages.map((img, index) => {
            if (index === 0) return null;

            return (
                <div
                    key={"uploadedimage-" + index}
                    className="image-preview uploaded"
                    style={{backgroundImage: `url(${img.thumbnail})`}}
                    onClick={() => this.props.selectMainImage(index, 'uploaded')}
                >
                    <div className="remove" onClick={e => {this.props.removeImage(index, 'uploaded'); e.stopPropagation()}}>
                        <span>x</span>
                    </div>
                </div>
            )
        })
    }

    renderMainImage() {
        if (!this.props.files && !this.props.uploadedImages) return '';

        let mainImage = {};
        let imageType = '';
        if (this.props.uploadedImages && this.props.uploadedImages[0]) {
            mainImage = this.props.uploadedImages[0].thumbnail;
            imageType = 'uploaded';
        } else if(this.props.files && this.props.files[0]) {
            mainImage = this.props.files[0].preview;
            imageType = 'new';
        } else {
            return '';
        }

        return (
            <div className="main-image-preview" draggable>
                <div className="image-preview" style={{backgroundImage: `url(${mainImage})`}}>
                    <div className="remove" onClick={() => this.props.removeImage(0, imageType) }>
                        <span>x</span>
                    </div>
                </div>
            </div>
        )
    }

    getSizeClass() {
        if (!this.props.files || this.props.files.length < 1) return '';

        if (this.props.files.length === 1) return 'one-image';
        if (this.props.files.length < 4) return 'one-line';
        if (this.props.files.length < 5) return 'two-line';

        return 'full';
    }

    renderNewImages() {
        if (!this.props.files) return null;

        const isUploadedImages = this.props.uploadedImages && this.props.uploadedImages.length > 0;
        return this.props.files.map((item, index) => {
            if (!isUploadedImages && index === 0) return null;

            return (
                <div
                    key={"uploadedimage-" + index}
                    className="image-preview new"
                    style={{backgroundImage: `url(${item.preview})`}}
                    onClick={() => this.props.selectMainImage(index, 'new')}
                >
                    <div className="remove" onClick={e => {this.props.removeImage(index, 'new'); e.stopPropagation()}}>
                        <span>x</span>
                    </div>
                </div>
            );
        })
    }

    renderSizes() {
        // 16:9 all mobile pin view
        // 3:2 all  web pin view
        // 3:2 free
        // 3:2 push
        // 3:2 rule
        // 16:9 super
    }

    renderSizesBtn() {
        return (
            <div className={`sizes-button-wrapper ${this.state.isSizesOpen ? 'open' : ''}`}>
                <span>Sizes</span>
            </div>
        )
    }

    render() {
        if (!this.props) return null;

        // File type or size is not allowed.
        return (
            <div className="imagesUpload rtl">
                <div className="top-wrapper">
                    {this.renderMainImage()}
                    <Dropzone
                        onDrop={this.props.onDrop}
                        minSize={1000}
                        maxSize={50000000} // 20MB
                        accept={"image/*"}
                        className={`dropzone ${this.getSizeClass()}`}
                    >
                        <div className="addImage">
                            { this.props.uploadSuccess === 0 ? <div className="uploadMessage">סוג או גודל קובץ לא מורשים</div> : null }
                            <img src={this.getMainImage()} role="presentation" alt="add-icon"/>
                            <div className="text">
                                הוסיפו תמונות
                            </div>
                        </div>
                    </Dropzone>
                </div>
                <div className="secondary-images-preview">
                    {this.renderImages()}
                    {this.renderNewImages()}
                </div>

            </div>
        )
    }
}

ImagesUpload.propTypes = {
    uploadSuccess: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    onDrop: PropTypes.func,
    removeImage: PropTypes.func,
    uploadedImages: PropTypes.array,
    files: PropTypes.array,
    selectMainImage: PropTypes.func
};

export default ImagesUpload;




// WEBPACK FOOTER //
// ./src/Components/Users/Submit/ImagesUpload.js